import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/close-icon-2.svg'
import _imports_1 from '@/assets/trash-icon-black.svg'


const _hoisted_1 = { class: "fixed top-0 right-0 bottom-0 left-0 z-[888] flex items-center justify-center w-full bg-black/80" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white w-full max-w-[628px] py-4 px-5 rounded-primary-radius"
}
const _hoisted_3 = { class: "w-full flex items-center justify-between border-b border-b-black/10 pb-4 mb-4" }
const _hoisted_4 = { class: "text-primary-text-color font-semibold text-xl leading-8 tracking-[0.01rem]" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-red-400 font-medium mt-1"
}
const _hoisted_7 = { class: "mt-4 w-full flex items-center justify-end gap-4" }
const _hoisted_8 = { class: "text-primary-text-color text-base leading-5 tracking-[0.01rem] font-semibold" }

import { useTranslate } from "@/composables/useTranslate";
import { FocusImage } from "@/types";
import { reactive } from "vue";
import { ref } from "vue";
import FocusModeDeleteModal from "./FocusModeDeleteModal.vue";

type Props = {
  isModalOpen: boolean;
  image: FocusImage | null;
};

type Emits = {
  (event: "onClose"): void;
  (event: "onAddImageComment", comment: string, logId: number): void;
  (event: "onDeleteImageComment"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FocusModeNoteModal',
  props: {
    isModalOpen: { type: Boolean },
    image: {}
  },
  emits: ["onClose", "onAddImageComment", "onDeleteImageComment"],
  setup(__props: any, { emit: __emit }) {

const { t } = useTranslate();

const props = __props;
const emits = __emit;
const comment = ref(props.image?.comment);

const isDeleteModalOpen = ref(false);

const errors = reactive({
  comment: "",
});

const validate = () => {
  let isValid = [];
  errors.comment = "";

  if (!comment.value) {
    errors.comment = t("focus_mode_modal.error_comment_mandatory").value;
    isValid.push(false);
  } else {
    isValid.push(true);
    errors.comment = "";
  }

  return isValid.filter((item: boolean) => !item).length === 0;
};

const onSubmit = () => {
  if (!validate()) return;

  emits(
    "onAddImageComment",
    comment.value ? comment.value : "",
    props.image?.logId ? props.image.logId : 0
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (__props.isModalOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)("focus_mode_modal.note")), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClose'))),
                  class: "flex items-center justify-center"
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Close"
                  }, null, -1)
                ]))])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event)),
                type: "text",
                class: _normalizeClass(["p-3 border rounded-primary-radius outline-none w-full bg-[#F9F8F6] text-base leading-[26px] tracking-[0.01rem] font-normal text-black duration-300", 
            comment.value && comment.value?.length > 0
              ? 'border-primary-text-color'
              : 'border-black/10'
          ]),
                placeholder: _unref(t)('focus_mode_modal.note').value
              }, null, 10, _hoisted_5), [
                [_vModelText, comment.value]
              ]),
              (errors.comment)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errors.comment), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isDeleteModalOpen.value = true)),
                  class: "flex items-center gap-2 p-3 rounded-primary-radius bg-[#F4B6B2]"
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("img", {
                    class: "w-[18px] h-[18px]",
                    src: _imports_1,
                    alt: "Delete"
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("focus_mode_modal.delete_note")), 1)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(FocusModeDeleteModal, {
                    "is-modal-open": isDeleteModalOpen.value,
                    text: _unref(t)('focus_mode_modal.focus_delete_note_modal_message'),
                    "is-delete-note": true,
                    "is-loading": false,
                    onOnCommentDelete: _cache[3] || (_cache[3] = ($event: any) => (emits('onDeleteImageComment'))),
                    onOnClose: _cache[4] || (_cache[4] = ($event: any) => (isDeleteModalOpen.value = false))
                  }, null, 8, ["is-modal-open", "text"])
                ]),
                _createElementVNode("button", {
                  onClick: onSubmit,
                  class: "w-full max-w-[150px] p-3 rounded-primary-radius bg-primary-text-color text-white text-base leading-5 tracking-[0.01rem] font-semibold"
                }, _toDisplayString(_unref(t)("global.save")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})